import {Shop} from "./shop";
import {Prices} from "./prices";
import {Category} from "./category";
import {QuantityByValues} from "./quantityByValues";

/** Class used in the product filter. */
export class Filter {

    /** Array of shops. */
    public shops: Array<Shop>;

    /** Array with prices that products can be filtered. */
    public prices: Array<Prices>;

    /** Array with categories that products can be filtered. */
    public categories: Array<Category>;

    /** Text typed into the search bar to search for a product. */
    public searchQuery: string;

    /** Quantity of products available when filtering prices. */
    public values: QuantityByValues;


    constructor(
        shops = new Array<Shop>(),
        prices = new Array<Prices>(),
        categories = new Array<Category>(),
        searchQuery = '',
        values = new QuantityByValues(),
    ) {
        this.shops = shops;
        this.prices = prices;
        this.categories = categories;
        this.searchQuery = searchQuery;
        this.values = values;
    }
}